var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack508({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.06,9.69a1.25,1.25,0,0,1-.62-.49,1.29,1.29,0,0,1-.2-.69,1.38,1.38,0,0,1,.45-1.06A1.79,1.79,0,0,1,8,7a1.79,1.79,0,0,1,1.27.42,1.38,1.38,0,0,1,.45,1.06,1.26,1.26,0,0,1-.21.71,1.24,1.24,0,0,1-.58.47,1.61,1.61,0,0,1,.73.56,1.54,1.54,0,0,1,.25.85,1.72,1.72,0,0,1-.51,1.29A1.85,1.85,0,0,1,8,12.88a2,2,0,0,1-1.3-.41,1.58,1.58,0,0,1-.61-1.32,1.7,1.7,0,0,1,.23-.86A1.47,1.47,0,0,1,7.06,9.69ZM7.18,11a1,1,0,0,0,.23.71A.76.76,0,0,0,8,12a.75.75,0,0,0,.57-.24,1,1,0,0,0,.22-.71.9.9,0,0,0-.23-.64A.72.72,0,0,0,8,10.16a.67.67,0,0,0-.6.28A1,1,0,0,0,7.18,11Zm.1-2.45a.69.69,0,0,0,.19.51A.67.67,0,0,0,8,9.28a.68.68,0,0,0,.5-.18.69.69,0,0,0,.19-.52.64.64,0,0,0-.19-.49A.66.66,0,0,0,8,7.9a.65.65,0,0,0-.69.69Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack508);
export default __webpack_public_path__ + "static/media/Symbolpack_5_08.7d089d6b3b7282a262e9c6cde96c90bf.svg";
export { ForwardRef as ReactComponent };